import { useQuery } from "@tanstack/react-query";
import { AdminApi } from "../../api/services";
import { PageHeader, Spinner, StatusBadge } from "../../components/common";
import { DataTable } from "../../components/DataTable";
import { dateTime, peso } from "../../lib/format";

export default function AdminTransactions() {
  const { data, isLoading } = useQuery({ queryKey: ["admin", "transactions"], queryFn: AdminApi.transactions, refetchInterval: 30000 });
  if (isLoading) return <Spinner />;
  const paid = (data || []).filter((p) => p.status === "paid");
  return (
    <div className="space-y-4">
      <PageHeader title="Transactions" subtitle={`${paid.length} paid · ${peso(paid.reduce((s, p) => s + p.amount, 0))} total`} />
      <DataTable testId="transactions-table" rows={data || []} columns={[
        { key: "date", label: "Created", render: (p) => dateTime(p.created_at) },
        { key: "user", label: "Payer", render: (p) => p.user_email },
        { key: "desc", label: "For", render: (p) => <span>{p.description}<span className="block text-xs capitalize text-slate-500">{p.purpose}</span></span> },
        { key: "amount", label: "Amount", render: (p) => <strong>{peso(p.amount)}</strong> },
        { key: "provider", label: "Provider", render: (p) => p.provider === "simulated"
          ? <span className="rounded border border-dashed border-amber-400 bg-amber-50 px-1.5 py-0.5 font-mono text-[10px] uppercase text-amber-900">Test / simulated</span>
          : `PayMongo (${p.mode})` },
        { key: "status", label: "Status", render: (p) => <StatusBadge status={p.status} /> },
        { key: "confirmed", label: "Confirmed by", render: (p) => <span className="text-xs text-slate-500">{p.confirmed_by || "—"}</span> },
      ]} />
    </div>
  );
}
